import { StatsSection } from "@cinch-nx/landing-ui-shared";
import { ContentWithIcon, HelpMeChoose, Intro, Prefooter } from "../components";
export var storyblokComponents = {
    GenericContentWithImageSection: Intro,
    ContentWithIconSection: ContentWithIcon,
    HelpMeChooseCTASection: HelpMeChoose,
    PrefooterCTA: Prefooter,
    StatsSection: StatsSection
};
